export const FORMS_WIDTH = 520;
export const FORMS_MARGIN_RIGHT = 20;
